import { env } from '@skin-seoul/env-utils';
import type { AxiosInstance } from 'axios';
import axios from 'axios';
import qs from 'qs';

const WORDPRESS_BASE_URL = (
  env('NEXT_PUBLIC_ENV') === 'LOCAL'
    ? env('NEXT_PUBLIC_ENV_CLOUDFLARE_IMAGE_ORIGIN')
    : env('NEXT_PUBLIC_ENV_FRONTEND_ORIGIN')
) as string;

/**
 * you can use next cache with fetchOptions
 *
 * example:
 * const { data } = await client.get('/products', {
 *   fetchOptions: {
 *     next: {
 *       revalidate: 60,
 *     },
 *     cache: 'force-cache',
 *   },
 */

export const createSkinSeoulWordpressClient = (_baseURL?: string): AxiosInstance => {
  const baseURL = _baseURL || WORDPRESS_BASE_URL;

  // Debug logging for environment context
  const isServer = typeof window === 'undefined';
  const hasGlobalEnv = typeof globalThis !== 'undefined' && !!(globalThis as any).__ENV;

  console.debug('[service/client] Creating HTTP client:', {
    isServer,
    hasGlobalEnv,
    baseURL,
    envSource: hasGlobalEnv ? 'globalThis.__ENV' : 'process.env or fallback',
  });

  return axios.create({
    baseURL: WORDPRESS_BASE_URL,
    withCredentials: true,
    adapter: 'fetch',
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  });
};

export let wordpressClient: AxiosInstance = createSkinSeoulWordpressClient();

export const setWordpressClient = (instance: AxiosInstance) => {
  wordpressClient = instance;
};
